import { render, staticRenderFns } from "./_base-hero.vue?vue&type=template&id=5556002b&scoped=true"
import script from "./_base-hero.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-hero.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-hero.vue?vue&type=style&index=0&id=5556002b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5556002b",
  null
  
)

export default component.exports